import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationInfusionRedLabelActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-infusion-red-label-slot-v2',
    templateUrl: './medication-infusion-red-label-slot-v2.component.html',
    styleUrl: './medication-infusion-red-label-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionRedLabelSlotComponentV2 implements SheetSlotComponentBase {

	action!: MedicationInfusionRedLabelActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationInfusionRedLabelActionV2 | null) {
		this.action = action as MedicationInfusionRedLabelActionV2;
		this.value = this.action.rate?.value?.toString() ?? null;
	}

	constructor() {
	}
}